// modules
import { setCachedFileHandlers } from '@weblite/file'
import { DBFindOne, DBInsert } from '@weblite/persist'

// handlers
const get = url => DBFindOne('cachedFiles', url)
const insert = (url, file) => DBInsert('cachedFiles', { url, file })
// const update = (url, ops) => DBUpdate('cachedFiles', { url }, ops)
// const remove = url => DBRemove('cachedFiles', url)

setCachedFileHandlers({ get, insert /* , update, remove */ })
